import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfDetailsComponent } from './pdf-details/pdf-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { ScansComponent } from './scans.component';
import { AddScansComponent } from './add-scans/add-scans.component';

@NgModule({
    declarations: [ScansComponent, PdfDetailsComponent, AddScansComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatSliderModule
    ],
    exports: [ScansComponent]
})
export class ScansModule { }
